<template>
  <div class="content">
    <Loader v-if="saving" />
    <h1>Product bulk update</h1>

    <div>
      <Tabs :tabs="tabs" v-model="active_tab" v-on:change="tabChanged" />
    </div>

    <div>
      <div>
        <div class="small-padding-right small-padding-bottom">
          <p class="bold">Product IDs (one per line):</p>
          <textarea name="productIds" cols="30" rows="10" v-model="products"></textarea>
        </div>
      </div>
      <div v-show="active_tab === 'season_tags'">
        <fieldset>
          <legend class="bold"> Select tag to be updated </legend>
          <TagSelector v-on:tag-selected="seasonTagSelected" tag-type="season" selection-type="single" />
        </fieldset>
        <div class="small-margin-top">
          <button :disabled="saving" v-on:click="updateSeasonTag()" class="btn-sm">Update</button>
        </div>
      </div>

      <div>
        <div v-show="active_tab === 'tags'">
          <fieldset class="green">
            <legend class="bold">Select tags to be added (+)</legend>
            <TagSelector v-on:tag-selected="tagsToAddSelected" :excluded-tags="tagsToRemove" tag-type="non-season" selection-type="multiple"/>
          </fieldset>
          <fieldset class="margin-top red">
            <legend class="bold">Select tags to be removed (x)</legend>
            <TagSelector v-on:tag-selected="tagsToRemoveSelected" :excluded-tags="tagsToAdd" tag-type="non-season" selection-type="multiple"/>
          </fieldset>
          <div class="small-margin-top">
            <button v-on:click="updateTag()" class="btn-sm">Submit</button>
          </div>
        </div>
        <div v-show="active_tab === 'colorful'">
          <div>
            <p class="bold">Colorful:</p>
            <select class="select" type="select" v-model="colorfulId">
              <option value="">&lt;&dash; Select &dash;&gt;</option>
              <option v-for="row in productOptions" v-if="row.category === 'colorful'" :value="row.id" v-text="capitalizeFirstLetter(row.name)"></option>
            </select>
          </div>
          <div class="small-margin-top">
            <button v-on:click="updateColorFul()" class="btn-sm">Apply</button>
          </div>
        </div>
        <div v-show="active_tab === 'patterns'">
          <div>
            <p class="bold">Patterns:</p>
            <select class="select" type="select" v-model="patternId">
              <option value="">&lt;&dash; Select &dash;&gt;</option>
              <option v-for="row in productOptions" v-if="row.category === 'patterns'" :value="row.id" v-text="capitalizeFirstLetter(row.name)"></option>
            </select>
          </div>
          <div class="small-margin-top">
            <button v-on:click="updatePatterns()" class="btn-sm">Apply</button>
          </div>
        </div>
        <div v-show="active_tab === 'add_discount'">
          <div>
            <p class="bold">Discount percentage: </p>
            <input type="number" class="smaller" v-model="discountPercentage"><span class="bold"> % </span>
          </div>
          <div class="small-margin-top">
            <button v-on:click="addDiscount()" class="btn-sm">Apply</button>
          </div>
        </div>
        <div v-show="active_tab === 'remove_discount'">
          <div class="small-margin-top">
            <button :disabled="saving" v-on:click="removeDiscount()" class="btn-sm">Apply</button>
          </div>
        </div>
        <div v-show="active_tab === 'block_recommender'">
          <div class="small-margin-top">
            <button v-on:click="blockRecommender()" class="btn-sm">Block</button>
          </div>
        </div>
        <div v-show="active_tab === 'unblock_recommender'">
          <div class="small-margin-top">
            <button v-on:click="unblockRecommender()" class="btn-sm">Unblock</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.width-half {
  width: 50%;
}
.hand {
  cursor: pointer;
}
</style>

<script>

import Vue from "vue";
import TagSelector from '@/components/TagSelector.vue'
import _ from 'lodash'

export default {
  components: {
    TagSelector
  },
  data: () => ({
    seasonTags: [],
    tagsToAdd: [],
    tagsToRemove: [],
    discountPercentage: null,
    products: '',
    productOptions: [],
    colorfulId: null,
    patternId: null,
    errorMessage: [],
    data: {},
    saving: false,
    active_tab: 'season_tags'
  }),
  computed: {
    tabs () {
      return {
        season_tags: {
          name: 'Season tags'
        },
        tags: {
          name: 'Tags'
        },
        colorful: {
          name: 'Colorful'
        },
        patterns: {
          name: 'Pattern'
        },
        add_discount: {
          name: 'Add discount'
        },
        remove_discount: {
          name: 'Remove discount'
        },
        block_recommender: {
          name: 'Block recommender'
        },
        unblock_recommender: {
          name: 'Unblock recommender'
        }
      }
    }
  },
  methods: {
    updateSeasonTag () {
      if (!this.validateProductSelection()) {
        return;
      }
      if (this.seasonTags.length === 0) {
        alert("Please select season tag.");
        return;
      }
      const param = {
        tags: this.seasonTags.map(t => t.tag_id),
        products: this.parseProductId()
      };
      Vue.$api.patch('/product/bulk-update/season-tag', param, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.bulkUpdated(data)
      })
    },
    updateTag () {
      if (!this.validateProductSelection()) {
        return;
      }
      if (this.tagsToAdd.length === 0 && this.tagsToRemove.length === 0) {
        alert("Please select tag.");
        return;
      }
      const productIds = this.parseProductId();
      productIds.forEach((productId) => {
        this.tagsToAdd.forEach((tag) => {
          Vue.$api.post('/product/' + productId + '/tag/' + tag.tag_id, {}, {
            before: () => this.saving = true,
            always: () => this.saving = false,
            callback: data => this.bulkUpdated(data)
          })
        })
        this.tagsToRemove.forEach((tag) => {
          Vue.$api.delete('/product/' + productId + '/tag/' + tag.tag_id, {}, {
            before: () => this.saving = true,
            always: () => this.saving = false,
            callback: data => this.bulkUpdated(data)
          })
        })
      });
    },
    updateColorFul () {
      if (!this.validateProductSelection()) {
        return;
      }
      if (this.colorfulId === undefined || this.colorfulId  === null) {
        alert("Please select colorful.");
        return;
      }
      const productIds = this.parseProductId();
      productIds.forEach((productId) => {
        Vue.$api.patch('/product/' + productId + '/colorful/' + this.colorfulId, {}, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.bulkUpdated(data)
        })
      });
    },
    updatePatterns () {
      if (!this.validateProductSelection()) {
        return;
      }
      if (this.patternId === undefined || this.patternId  === null) {
        alert("Please select pattern.");
        return;
      }
      const productIds = this.parseProductId();
      productIds.forEach((productId) => {
        Vue.$api.patch('/product/' + productId + '/pattern/' + this.patternId, {}, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.bulkUpdated(data)
        })
      });
    },
    addDiscount () {
      if (!this.validateProductSelection()) {
        return;
      }
      if (this.discountPercentage === null) {
        alert("Please set discount percentage value");
        return;
      }
      const productIds = this.parseProductId();
      productIds.forEach((productId) => {
        Vue.$api.post('/product/' + productId + '/apply-discount', {
          percentage: this.discountPercentage
        }, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.bulkUpdated(data)
        })
      });
    },
    removeDiscount () {
      if (!this.validateProductSelection()) {
        return;
      }
      const productIds = this.parseProductId();
      productIds.forEach((productId) => {
        Vue.$api.post('/product/' + productId + '/apply-discount', {
          percentage: 0
        }, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.bulkUpdated(data)
        })
      });
    },
    blockRecommender () {
      if (!this.validateProductSelection()) {
        return;
      }
      const productIds = this.parseProductId();
      productIds.forEach((productId) => {
        Vue.$api.post('/product/' + productId + '/block-recommender', {}, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.bulkUpdated(data)
        })
      });
    },
    unblockRecommender () {
      if (!this.validateProductSelection()) {
        return;
      }
      const productIds = this.parseProductId();
      productIds.forEach((productId) => {
        Vue.$api.post('/product/' + productId + '/unblock-recommender', {}, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.bulkUpdated(data)
        })
      });
    },
    validateProductSelection() {
      if (!confirm('Are you sure of those changes?')) {
        return false;
      }
      if (this.products.length === 0) {
        alert("Product IDs are required !!")
        return false;
      }
      return true;
    },
    parseProductId() {
      return this.products
        .split('\n')
        .map(id => id.trim())
        .filter(id => id)  // filter out empty strings
        .map(id => parseInt(id));
    },
    tabChanged (tab) {
      switch (tab.id) {
        default:
          break
      }
    },
    seasonTagSelected (tags) {
      this.seasonTags = tags
    },
    tagsToAddSelected (tags) {
      this.tagsToAdd = tags
    },
    tagsToRemoveSelected (tags) {
      this.tagsToRemove = tags
    },
    bulkUpdated() {
      // this.reset();
      this.saving = false
    },
    reset () {
      this.products = ''
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
  },
  created () {
    Vue.api.get('/product-options', {}, {
      callback: data => {
        this.productOptions = data
      }
    })
  }
}
</script>
